if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          // CU-869e1uxce: push dl_view_item for Elevar/GTM, mirroring the real PDP event.
          // Runs first so it can't be skipped if the Yotpo/swym calls below throw
          // (e.g. Yotpo's app-embed script hasn't loaded yet).
          this.pushViewItemDataLayer();

          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // refresh yotpo modules
          if (window.Yotpo && window.Yotpo.API) {
            var api = new window.Yotpo.API(window.yotpo);
            if(api) {
              api.refreshWidgets();
            }
          }

          // refreshing swym wishlist hearth button
					document.dispatchEvent(new CustomEvent("swym:quick-modal-loaded"));

          setTimeout(() => {
            const vieveSociety = document.querySelector('.vieve-society');
            const nonVieveSociety = document.querySelector('.non-vieve-society');
            const customer = swymCustomerId;
            const vieveMetafield = vieveSociety.getAttribute('data-metafield');
            const isQuickview = vieveSociety.getAttribute('data-quickview');
      
            if(customer && vieveMetafield == 'true' && isQuickview == 'false') {
              vieveSociety.style.display = 'block';
              nonVieveSociety.style.display = 'none';
            } else {
              nonVieveSociety.style.display = 'block';
              vieveSociety.style.display = 'none';
            }
          }, 300);
        });
    }

    pushViewItemDataLayer() {
      const dataEl = this.modalContent.querySelector('.quick-add-view-item-data');
      if (!dataEl) return;

      const data = JSON.parse(dataEl.textContent);
      const currentPath = window.location.pathname;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dl_view_item',
        ecommerce: {
          currencyCode: data.currencyCode,
          detail: {
            actionField: { list: currentPath },
            products: [{
              id: data.id,
              name: data.name,
              brand: data.brand,
              category: data.category,
              variant: data.variant,
              price: data.price,
              list: currentPath,
              product_id: data.product_id,
              variant_id: data.variant_id,
              compare_at_price: data.compare_at_price,
              image: data.image
            }]
          }
        }
      });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
